const css = `.oSofWW__wrapper{overflow:hidden}.oSofWW__flex{height:100%}.oSofWW__calendar{width:max-content;position:relative}.oSofWW__overlay{height:32px;background:var(--base-surfaces-default);border-bottom:1px solid var(--base-strokes-default);z-index:1}.oSofWW__content{height:calc(100% - 32px)}.oSofWW__daysOfWeek{grid-template-columns:repeat(7,1fr);display:grid}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"calendar":"oSofWW__calendar","flex":"oSofWW__flex","wrapper":"oSofWW__wrapper","overlay":"oSofWW__overlay","content":"oSofWW__content","daysOfWeek":"oSofWW__daysOfWeek"};
